import { RouteEntry } from 'framework/routing/routeEntry';
import { AssetsListProps } from 'areas/assets/assets-grid/types';

export function getRoute(): RouteEntry<AssetsListProps> {
	return {
		url: '/assets',
		getModuleImport: async () => await import('areas/assets/assets-grid/assetsGrid'),
		routeId: 'assethealth_summary',
	};
}
